import type { CSSProperties } from 'react'
import './WrapXs2a.css'

interface WrapXs2aProps {
  display?: string
}

export const WrapXs2a = (props: WrapXs2aProps) => {
  return (
    <div
      className="wrap-xs2a onboarding-Xs2a-wrap-container"
      style={
        {
          '--xs2a-display': props.display || undefined,
        } as CSSProperties
      }
    >
      <div id="XS2A-Form" data-xs2a="" />
    </div>
  )
}
